var am4core, am4charts;
var am4langSE = require('./localization-se');
var am4exportMenu = require('./components/export-menu');
var am4PieChart = require('./pie-chart');
var am4XYChart = require('./xy-chart');
var am4Bar3DChart = require('./bar3d-chart');
var am4TrackChart = require('./track-chart');
var am4BubbleChart = require('./bubble-chart');
var am4MapChart = require('./map-chart');
var am4Helpers = require('./helpers');

global.graphblock = (function ($) {
	var graphblockCount = 0;
	var mapCharts = [];

	var createChart = function ($graphblock) {
		var chartType = $graphblock.data('charttype');
		var chart;
		var chartName = $graphblock.data('chartname');
		var data = am4Helpers.cleanData($graphblock.data('chartdata').DataPoints);
		/* jshint ignore:start */
		window.am4core.unuseTheme(window.am4themes_animated);
		/* jshint ignore:end */

		switch (chartType) {
		case 'Pie':
			chart = am4PieChart.createPieChart($graphblock, data);
			break;
		case 'Bar3D':
			chart = am4Bar3DChart.createBar3DChart($graphblock, data);
			break;
		case 'MapChart':
			chart = am4MapChart.createMapChart($graphblock, data);
			mapCharts.push(chart);
			break;
		case 'BubbleChart':
			chart = am4BubbleChart.createBubbleChart($graphblock, data);
			break;
		default:
			chart = am4XYChart.createXYChart($graphblock, data);
		}

		if (document.documentElement.lang === 'sv') {
			chart.language.locale = am4langSE;
		}

		if (document.documentElement.lang === 'en-GB')  {
			chart.dateFormatter.inputDateFormat = 'dd-MM-yyyy';
		}

		if (chartType !== 'Bar3D' && chartType !== 'MapChart') {
			am4Helpers.setChartHeight(chart, chartType);
		}

		am4Helpers.setNumberFormat(chart,
			$graphblock.data('yaxisdecimals'),
			$graphblock.data('numberofdecimals'));

		am4exportMenu.createExportMenu(chart, chartName,
			$graphblock.data('exporturlexcel'), $graphblock.data('exporturlcsv'));
		am4TrackChart.trackEvents(chartName, chart);
		chart.readerTitle = chartName;

		if (mapCharts.length > 0) {
			addEventListener("resize", (event) => { });
			onresize = (event) => {
				for (var i = 0; i < mapCharts.length; i++) {
					// Place the legend rougly 1/3 of the width of the chart from the right side
					mapCharts[i].legend.marginRight = Math.max(0, $graphblock[0].clientWidth / 3 - 100);
				}
			};
		}

	};

	var initGraphBlocks = function ($graphblocks) {
		$graphblocks.each(function () {
			$(this).attr('id', 'chart' + graphblockCount); //Generate charts with unique ID's
			graphblockCount++;
			createChart($(this));
		});
	};

	var updateGraphblocks = function () {
		var $graphblocks = $('.graph-block:empty'); //Select the graph blocks that have not been generated yet
		if ($graphblocks.length === 0) { return; }

		if (am4core === undefined || am4charts === undefined || am4maps === undefined) {
			am4core = window.am4core;
			am4core.addLicense("AM5C11207728551121");
			am4core.options.commercialLicense = true; // This removes the amCharts logo
			am4charts = window.am4charts;
			am4maps = window.am4maps;
		}

		initGraphBlocks($graphblocks);
	};

	updateGraphblocks();

	return {
		updateGraphblocks: updateGraphblocks
	};
})(jQuery);
